/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateCompanyBrandDto } from './createCompanyBrandDto';


export interface UpdateCompanyDto { 
    name?: string;
    acronym?: string;
    brands?: Array<CreateCompanyBrandDto>;
}

